module.exports = __webpack_public_path__ + "media/src/shared_components/images/add_to_playlist-9f305cb621e77470c953fc4dc1577b84.svg";